import { useCallback, useState } from "react";
import { ChartElement, useContainer, usePresenter, usePresenterEvents } from "./types";
//import Plot from "react-plotly.js";
import { DataMessages } from "../core/hooks/useData";
import { getObjectValue } from "../core/utils/objectPath";
import { useDebounce, useDelayedDebounce } from "../core/hooks/useDebounce";


declare  const Plot: any;

export function Chart(props: {
	def: ChartElement,
}) {

	const presenter = usePresenter();
	const container = useContainer();

	function getFromContainer(containerItems: any[], containerID: string, prop: string) {
		for(let a of containerItems) {
			if (a.containerID === containerID) {
				return getObjectValue(a, prop);
			}
		}
		return undefined;
	}

	const [delayedData, queueUpdate] = useDelayedDebounce(
		250, 
		{
			values: [] as number[],
			labels: [] as string[],
		},
		() => {
			const labels = [];
			const values = [];

			const allocs = presenter.getValue("shares", { dataState: container.data });
			const parties = presenter.getValue("parties", { dataState: container.data });
			if (allocs) {

				for(let a of allocs) {
					if (!a.holders) continue;

					const holders = a.holders;

					let label = [];
					for(let h of holders) {
						label.push(getFromContainer(parties, h, "entity.display"));
					}

					values.push(a.shareCount);
					labels.push(label.join(", "));
				}

				return{
					values,
					labels,
				};	
			}
		}
	);

	usePresenterEvents(presenter, useCallback((msg: any) => {

		if (msg.type === DataMessages.CHANGE) {
			queueUpdate();
		}


	}, [presenter]));


	if (!delayedData || delayedData.values.length <= 0) return null;

	return (
		<Plot
			config={{
				displaylogo: false,
				displayModeBar: false,
				//autosizable: false,
				editable: false,	
				//responsive: false,
				showTips: false,
				showSources: false,

			}}

			data={[
				{
					...delayedData,
					type: "pie",
					hole: 0.5,
				}
			]}
			layout={{
				//width: 500, height: 500
				//, title: 'A Fancy Plot'
				margin: {
					b: 50,
				},
				legend: {
					valign: "top",
					orientation: "h",
					traceorder: "normal",
					// x: 1000,
					// y: 0,
					//itemsizing: "trace",
					//itemwidth: 50,

					bgcolor: "transparent"
				}
			}}
		/>
	);
}